import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ExpertiseCard from './ExpertiseCard';
import type { ExpertiseArea } from '../types';

interface ExpertiseSectionProps {
  expertiseAreas: ExpertiseArea[];
}

const ExpertiseSection = ({ expertiseAreas }: ExpertiseSectionProps) => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.6 }}
      className="max-w-6xl mx-auto mb-16"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
        {t('about.sections.expertise')}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {expertiseAreas.map((area, index) => (
          <ExpertiseCard key={index} expertise={area} index={index} />
        ))}
      </div>
    </motion.div>
  );
};

export default ExpertiseSection;